import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["searchInput"];
import { filterProps } from '../../../utils/filterProps';
import { FieldsetContextProvider } from '../../context/FieldsetContext';
import { FormControl } from '../FormControl';
import { TFlex } from '../TFlex';
import { jsx as _jsx } from "react/jsx-runtime";
export const TableActionsBar = _ref => {
  let {
      searchInput
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps,
    restProps
  } = filterProps(rest);
  return /*#__PURE__*/_jsx(TFlex, Object.assign({}, domProps, tokenProps, restProps, {
    backgroundColor: "fill-transitional-table-default",
    paddingBlock: "100",
    paddingInline: "200",
    borderColor: "border-transitional-core-subtle",
    borderStyle: "solid",
    borderWidth: "100",
    borderBlockEndWidth: "0",
    children: /*#__PURE__*/_jsx(FieldsetContextProvider, {
      size: "small",
      disabled: false,
      children: /*#__PURE__*/_jsx(FormControl, {
        inlineSize: "100%",
        maxInlineSize: "50%",
        children: searchInput
      })
    })
  }));
};